import { Pipe, PipeTransform } from '@angular/core';

import { SessionService } from './session.service';
import { TranslateService } from './translate.service';

@Pipe({ name: 'translate' })
export class TranslatePipe implements PipeTransform {
  constructor(
    private session: SessionService,
    private translate: TranslateService) {}

  transform(key: string, ...args: any[]): any {
    // let ret;
    return this.translate
      .getTranslations(this.session._productConfig.resx, this.session.lang)
      .map(t => t[key] || key);

    // return ret;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/commons/translate.pipe.ts